<template >
    <div v-if="!useContainerView"  style="margin: 10px;  position:relative;">
        <form role="form">
            <div class="container-fluid shadow">
                <div class="row">
                    <div class="row">
                        <div class="col-md-6">&nbsp;</div>
                        <div class="col-md-6">&nbsp;</div>
                    </div>

                    <div class="row">
                        <div class="col-md-12 text-left">
                            <label class="text-left">{{orderDetailLabels.dettaglioOrdineLbl}}</label>
                        </div>                    
                    </div>
                    <div class="row">
                        <div class="col-md-12">
                            <div style="display: inline-block; border-top: 1px solid lightgray; content: ''; top: 20px; right: 10em; vertical-align: top; bottom: 0; width: 100%;"> </div>
                        </div>                                
                    </div>
                    <div class="row">
                        <div class="col-md-6">
                            <div class="col-md-6">
                                <div class="form-group">
                                    <div class="col-sm-4" style="padding-left: 0px">
                                        <span class="align-middle label-cust">{{orderDetailLabels.idLbl}}</span>
                                    </div>
                                    <input-w v-model="idValue" :configs="orderDetailLabels">
                                        <div class="col-sm-8"><input readonly v-model="idValue" type="text" id="idValueId" class="form-control form-control-cust" /></div>
                                    </input-w>
                                </div>
                            </div>
                            <cfg cid="shopCart.tipoOrdine" tag='div'>
                            <div class="col-md-6">
                                <div class="form-group">
                                    <div class="col-sm-4"  style="padding-left: 0px">
                                        <span class="align-middle label-cust">{{orderDetailLabels.tipoOrdineLbl}}</span>
                                    </div>
                                    <input-w v-model="tipoOrdineValue" :configs="orderDetailLabels">
                                        <div class="col-sm-8" ><input readonly v-model="tipoOrdineValue" type="text" id="tipoOrdineValueId" class="form-control form-control-cust" /></div>
                                    </input-w>
                                </div>
                            </div>
                            </cfg>
                        </div>
                        <div class="col-md-6">
                            <div class="form-group">
                                <div class="col-sm-2" style="padding-left: 0px">
                                    <span class="align-middle label-cust">{{orderDetailLabels.statoOrdineLbl}}</span>
                                </div>
                                <input-w v-model="statoOrdineValue"  :configs="orderDetailLabels">
                                    <div class="col-sm-6 padLeft10"><input readonly type="text" v-model="statoOrdineValue" id="statoOrdineValueId" class="form-control form-control-cust" /></div>
                                </input-w>
                                <div v-if="changeStatusEnable" class="controls col-sm-4">
                                    <button @click.prevent="changeStatusClick" id="changeStatusBtnId"  class="btn btn-primary-default" style="width: 100px; padding: 3px; float: right;" :disabled="changeStatusNotClickable">{{changeStatusBtnLabel}}</button>
                                </div>

                            </div>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-md-6">
                            <cfg cid="shopCart.numOrdCli" tag='div'>
                            <div class="col-md-6">
                                <div class="form-group">
                                    <div class="col-sm-4" style="padding-left: 0px">
                                        <span class="align-middle label-cust">{{orderDetailLabels.numOrdineCliLbl}}</span>
                                    </div>
                                    <input-w v-model="numOrdineCliValue" :configs="orderDetailLabels">
                                        <div class="col-sm-8"><input readonly  v-model="numOrdineCliValue" type="text" id="numOrdineCliValueId" class="form-control form-control-cust" /></div>
                                    </input-w>
                                </div>
                            </div>
                            </cfg>
                            <cfg cid="shopCart.scontoBase" tag='div'>
                            <div v-if="!$root.token.hidePrices  && showScontoBase" class="col-md-6">
                                <div class="form-group">
                                    <div class="col-sm-4"  style="padding-left: 0px">
                                        <span class="align-middle label-cust">{{orderDetailLabels.scontoBaseLbl}}</span>
                                    </div>
                                    <input-w v-model="scontoBaseValue" :configs="orderDetailLabels">
                                        <div class="col-sm-8"><input readonly  v-model="scontoBaseValue" type="text" id="scontoBaseValueId" class="form-control form-control-cust" /></div>
                                    </input-w>
                                </div>
                            </div>
                            </cfg>
                        </div>
                    
                        <div v-if="document" class="col-md-6">
                            <div class="form-group">
                                <div class="col-sm-2" style="padding-left: 0px">
                                    <span class="align-middle label-cust">{{orderDetailLabels.documentiLbL}}</span>
                                </div>
                                <input-w>
                                    <div class="col-sm-6"><p><a :href="document.link" target="_blank" style="text-decoration: underline;">{{document.name}}</a></p></div>
                                </input-w>
                            </div>
                        </div>
                    
                    </div>
                    <div class="row">
                        <div class="col-md-6">
                            <div class="col-md-12">
                                <div class="form-group">
                                    <div class="col-sm-2" style="padding-left: 0px">
                                        <span class="align-middle label-cust">{{orderDetailLabels.clienteLbl}}</span>
                                    </div>
                                    <input-w v-model="clienteValue" :configs="orderDetailLabels">
                                        <div class="col-sm-10 padLeft10"><input readonly  v-model="clienteValue" type="text" id="clienteValueId" class="form-control form-control-cust" /></div>
                                    </input-w>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="form-group">
                                <div class="col-sm-12">
                                    &nbsp;
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-6">
                            <div class="col-md-12">
                                <div class="form-group">
                                    <div class="col-sm-2" style="padding-left: 0px">
                                        <span class="align-middle label-cust">{{orderDetailLabels.utenteLbl}}</span>
                                    </div>
                                    <input-w v-model="utenteValue" :configs="orderDetailLabels">
                                        <div class="col-sm-10 padLeft10"><input readonly  v-model="utenteValue" type="text" id="utenteValueId" class="form-control form-control-cust" /></div>
                                    </input-w>
                                </div>
                            </div>
                        </div>
                        <cfg cid="shopCart3.portType" tag='div'>
                        <div class="col-md-6">
                            <div class="form-group">
                                <div class="col-sm-2" style="padding-left: 0px">
                                    <span class="align-middle label-cust">{{orderDetailLabels.portoLbl}}</span>
                                </div>
                                <input-w v-model="portoValue" :configs="orderDetailLabels">
                                    <div class="col-sm-10 padLeft10"><input readonly  v-model="portoValue" type="text" id="portoValueId" class="form-control form-control-cust" /></div>
                                </input-w>
                            </div>
                        </div>
                        </cfg>
                    </div>

                    <div class="row">
                        <div class="col-md-6">
                            <cfg cid="shopCart.dataOrdine" tag='div'>
                            <div class="col-md-6">
                                <div class="form-group">
                                    <div class="col-sm-4" style="padding-left: 0px">
                                        <span class="align-middle label-cust">{{orderDetailLabels.dataOrdineLbl}}</span>
                                    </div>
                                    <input-w v-model="dataOrdineValue" :configs="orderDetailLabels">
                                        <div class="col-sm-8"><input readonly  v-model="dataOrdineValue" type="text" id="dataOrdineValueId" class="form-control form-control-cust" /></div>
                                    </input-w>
                                </div>
                            </div>
                            </cfg>
                            <cfg cid="shopCart3.shippingType" tag='div'>
                            <div class="col-md-6">
                                <div class="form-group">
                                    <div class="col-sm-4"  style="padding-left: 0px">
                                        <span class="align-middle label-cust">{{orderDetailLabels.tipoSpedizioneLbl}}</span>
                                    </div>
                                    <input-w v-model="tipoSpedizioneValue" :configs="orderDetailLabels">
                                        <div class="col-sm-8"><input readonly  v-model="tipoSpedizioneValue" type="text" id="tipoSpedizioneId" class="form-control form-control-cust" /></div>
                                    </input-w>
                                </div>
                            </div>
                            </cfg>
                        </div>
                        <cfg cid="shopCart.destinatarioIndirizzo" tag='div'>
                        <div class="col-md-6">
                            <div class="form-group">
                                <div class="col-sm-2" style="padding-left: 0px">
                                    <span class="align-middle label-cust">{{orderDetailLabels.destinatarioLbl}}</span>
                                </div>
                                <input-w v-model="destinatarioValue" :configs="orderDetailLabels">
                                    <div class="col-sm-10 padLeft10"><input readonly  v-model="destinatarioValue" type="text" id="destinatarioId" class="form-control form-control-cust" /></div>
                                </input-w>
                            </div>
                        </div>
                        </cfg>
                    </div>
                    <div class="row">
                        <div class="col-md-6">
                            <cfg cid="shopCart3.reqDeliveryDate" tag='div'>
                            <div class="col-md-6">
                                <div class="form-group">
                                    <div class="col-sm-4" style="padding-left: 0px">
                                        <span class="align-middle label-cust">{{orderDetailLabels.dataConsRichiestaLbl}}</span>
                                    </div>
                                    <input-w v-model="dataConsRichiestaValue" :configs="orderDetailLabels">
                                        <div class="col-sm-8"><input readonly  v-model="dataConsRichiestaValue" type="text" id="dataConsRichiestaId" class="form-control form-control-cust" /></div>
                                    </input-w>
                                </div>
                            </div>
                            </cfg>
                            <cfg cid="shopCart.importo" tag='div'>
                            <div v-if="!$root.token.hidePrices" class="col-md-6">
                                <div class="form-group">
                                    <div class="col-sm-4"  style="padding-left: 0px">
                                        <span class="align-middle label-cust">{{orderDetailLabels.valutaLbl}}</span>
                                    </div>
                                    <input-w v-model="valutaValue" :configs="orderDetailLabels">
                                        <div class="col-sm-8"><input readonly  v-model="valutaValue" type="text" id="valutaId" class="form-control form-control-cust" /></div>
                                    </input-w>
                                </div>
                            </div>
                            </cfg>
                        </div>
                        <div class="col-md-6">
                            <div class="form-group">
                                <div class="col-sm-2" style="padding-left: 0px">
                                    <span class="align-middle label-cust">{{orderDetailLabels.indirizzoLbl}}</span>
                                </div>
                                <input-w v-model="indirizzoValue" :configs="orderDetailLabels">
                                    <div class="col-sm-10 padLeft10"><input readonly  v-model="indirizzoValue" type="text" id="indirizzoId" class="form-control form-control-cust" /></div>
                                </input-w>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-6">
                            <cfg cid="shopCart.dataConferma" tag='div'>
                            <div class="col-md-6">
                                <div class="form-group">
                                    <div class="col-sm-4" style="padding-left: 0px">
                                        <span class="align-middle label-cust">{{orderDetailLabels.dataConfermaLbl}}</span>
                                    </div>
                                    <input-w v-model="dataConfermaValue" :configs="orderDetailLabels">
                                        <div class="col-sm-8"><input readonly  v-model="dataConfermaValue" type="text" id="dataConfermaId" class="form-control form-control-cust" /></div>
                                    </input-w>
                                </div>
                            </div>
                            </cfg>
                            <cfg cid="shopCart.importo" tag='div'>
                            <div v-if="!$root.token.hidePrices" class="col-md-6">
                                <div class="form-group">
                                    <div class="col-sm-4"  style="padding-left: 0px">
                                        <span class="align-middle label-cust">{{orderDetailLabels.totOrdineLbl}}</span>
                                    </div>
                                    <input-w v-model="totOrdineValue" :configs="orderDetailLabels">
                                        <div class="col-sm-8"><input readonly  v-model="totOrdineValue" type="text" id="totOrdineId" class="form-control form-control-cust" /></div>
                                    </input-w>
                                </div>
                            </div>
                            </cfg>
                        </div>
                        <div class="col-md-6">
                            <div class="form-group">
                                <div class="col-sm-2" style="padding-left: 0px">
                                    <span class="align-middle label-cust">{{orderDetailLabels.localitaLbl}}</span>
                                </div>
                                <input-w v-model="localitaValue" :configs="orderDetailLabels">
                                    <div class="col-sm-10 padLeft10"><input readonly  v-model="localitaValue" type="text" id="localitaId" class="form-control form-control-cust" /></div>
                                </input-w>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-6">
                            <cfg cid="shopCart.note" tag='div'>
                            <div class="form-group">
                                <div class="col-md-12">
                                    <div class="col-sm-2" style="padding-left: 0px">
                                        <span class="align-middle label-cust">{{orderDetailLabels.noteLbl}}</span>
                                    </div>
                                    <input-w v-model="noteValue" :configs="orderDetailLabels">
                                        <div class="col-sm-10 padLeft10"><input readonly  v-model="noteValue" type="text" id="noteId" class="form-control form-control-cust" /></div>
                                    </input-w>
                                </div>
                            </div>
                            </cfg>
                        </div>
                        <div class="col-md-6" style="padding-left: 0px; padding-right: 0px">
                            <div class="col-md-6" >
                                <div class="form-group">
                                    <div class="col-sm-4" style="padding-left: 0px">
                                        <span class="align-middle label-cust">{{orderDetailLabels.capLbl}}</span>
                                    </div>
                                    <input-w v-model="capValue" :configs="orderDetailLabels">
                                        <div class="col-sm-8"><input readonly  v-model="capValue" type="text" id="capId" class="form-control form-control-cust" /></div>
                                    </input-w>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group">
                                    <div class="col-sm-4">
                                        <span class="align-middle label-cust">{{orderDetailLabels.regioneLbl}}</span>
                                    </div>
                                    <input-w v-model="regioneValue" :configs="orderDetailLabels">
                                        <div class="col-sm-8"><input readonly  v-model="regioneValue" type="text" id="regioneId" class="form-control form-control-cust" /></div>
                                    </input-w>
                                </div>
                            </div>
                        </div>                  
                    </div>                
                    <div class="row">
                        <div class="col-md-6">
                            <cfg cid="shopCart.noteGestore" tag='div'>
                            <div class="form-group">
                                <div class="col-md-12">
                                    <div class="col-sm-2" style="padding-left: 0px">
                                        <span class="align-middle label-cust">{{orderDetailLabels.noteGestLbl}}</span>
                                    </div>
                                    <input-w v-model="noteGestValue" :configs="orderDetailLabels">
                                        <div class="col-sm-10 padLeft10"><input readonly  v-model="noteGestValue" type="text" id="noteGestId" class="form-control form-control-cust" /></div>
                                    </input-w>
                                </div>
                            </div>
                            </cfg>
                        </div>
                        <div class="col-md-6" style="padding-left: 0px; padding-right: 0px">
                            <div class="col-md-6">
                                <div class="form-group">
                                    <div class="col-sm-4" style="padding-left: 0px">
                                        <span class="align-middle label-cust">{{orderDetailLabels.provinciaLbl}}</span>
                                    </div>
                                    <input-w v-model="provinciaValue" :configs="orderDetailLabels">
                                        <div class="col-sm-8"><input readonly  v-model="provinciaValue" type="text" id="provinciaId" class="form-control form-control-cust" /></div>
                                    </input-w>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group">
                                    <div class="col-sm-4">
                                        <span class="align-middle label-cust">{{orderDetailLabels.nazioneLbl}}</span>
                                    </div>
                                    <input-w v-model="nazioneValue" :configs="orderDetailLabels">
                                        <div class="col-sm-8"><input readonly  v-model="nazioneValue" type="text" id="nazioneId" class="form-control form-control-cust" /></div>
                                    </input-w>
                                </div>
                            </div>
                        </div>                  
                    </div>                                
                    <div class="row">
                        <div class="col-md-12">
                            <div class="form-group">
                                <div style="padding: 5px;">
                                    <grid :columns="gridProdAttributesCfg.columns"
                                            :source.sync="arrayToTable" :options="options" :others="others"
                                            :lang="$root.token.idLingua" :name="gridProdAttributesCfg.title">
                                    </grid>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="controls col-sm-1" style="padding-left: 30px;">
                            <button @click.prevent="previousClick" class="btn btn-primary-default" style="width: 130px">{{$Jed.firstUpperTranslate('back')}}</button>        
                        </div>
                        <cfg cid="shopCart.printPreviewBtn" tag='div'>
                            <div class="col-sm-1"></div>
                            <div class="controls col-sm-2">
                                <button :disabled="!orderSynced" @click.prevent="$root.printOrder(idValue)"  class="btn btn-primary-default" style="width: 100%">{{$Jed.firstUpperTranslate('print preview')}}</button>
                            </div>
                        </cfg>
                    </div>                
                    <div class="row">
                        <div class="col-md-6">&nbsp;</div>
                        <div class="col-md-4">&nbsp;</div>
                        <div class="col-md-2">&nbsp;</div>
                    </div>
                    
                </div>
            </div>
        </form>

        <div v-if="this.sendingCart" style="opacity:1; background: rgba(255, 255, 255, 0.65); z-index: 9999; position: fixed;
            top: 0;
            left: 0;
            width: 100vw;
            height: 100vh;transition: opacity 0.3s;
            transform: translate3D(0, 0, 0);">
            <div class="sk-cube-grid" style="margin-top: 20%;">
                <div class="sk-cube sk-cube1 loading-nav-waiter"></div>
                <div class="sk-cube sk-cube2 loading-nav-waiter"></div>
                <div class="sk-cube sk-cube3 loading-nav-waiter"></div>
                <div class="sk-cube sk-cube4 loading-nav-waiter"></div>
                <div class="sk-cube sk-cube5 loading-nav-waiter"></div>
                <div class="sk-cube sk-cube6 loading-nav-waiter"></div>
                <div class="sk-cube sk-cube7 loading-nav-waiter"></div>
                <div class="sk-cube sk-cube8 loading-nav-waiter"></div>
                <div class="sk-cube sk-cube9 loading-nav-waiter"></div>
            </div>
        </div>

    </div>
    <div v-else style="margin: 10px;  position:relative;">
        <form role="form">

            <div class="container-fluid shadow">
                <div class="row">
                    <div class="row">
                        <div class="col-md-6">&nbsp;</div>
                        <div class="col-md-6">&nbsp;</div>
                    </div>

                    <div class="row">
                        <div class="col-md-12 text-left">
                            <label class="text-left">{{orderDetailLabels.dettaglioOrdineLbl}}</label>
                        </div>                    
                    </div>
                    <div class="row">
                        <div class="col-md-12">
                            <div style="display: inline-block; border-top: 1px solid lightgray; content: ''; top: 20px; right: 10em; vertical-align: top; bottom: 0; width: 100%;"> </div>
                        </div>                                
                    </div>
                </div>
            </div>
            <div class="container-fluid shadow">
                <div class="row">
                    <div class="col-xs-12 col-sm-12  col-md-12">
                        <div class="form-group">
                            <div class="col-xs-2 col-sm-2" style="padding-left: 0px">
                                <span class="align-middle label-cust">{{orderDetailLabels.statoOrdineLbl}}</span>
                            </div>
                            <input-w v-model="statoOrdineValue"  :configs="orderDetailLabels">
                                <div class="col-xs-6 col-sm-6 padLeft10"><input readonly type="text" v-model="statoOrdineValue" id="statoOrdineValueId" class="form-control form-control-cust" /></div>
                            </input-w>
                            <div v-if="changeStatusEnable" class="controls col-xs-4 col-sm-4">
                                <button @click.prevent="changeStatusClick" id="changeStatusBtnId"  class="btn btn-primary-default" style="width: 100px; padding: 3px; float: right;" :disabled="changeStatusNotClickable">{{changeStatusBtnLabel}}</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>


            <div class="container-fluid shadow">
                <div class="row  no-gutters">
                    <div class="col-xs-12 col-sm-12  col-md-12">
                        <div class="col-xs-6 col-md-6"  >
                            <div class="form-group">
                                <div class="col-xs-4 col-sm-4" style="padding-left: 0px">
                                    <span class="align-middle label-cust">{{orderDetailLabels.idLbl}}</span>
                                </div>
                                <input-w v-model="idValue" :configs="orderDetailLabels">
                                    <div class="col-xs-8  col-sm-8"><input readonly v-model="idValue" type="text" id="idValueId" class="form-control form-control-cust" /></div>
                                </input-w>
                            </div>
                        </div>
                        <cfg cid="shopCart.tipoOrdine" tag='div'>
                        <div class="col-xs-6 col-md-6">
                            <div class="form-group">
                                <div class="col-xs-4  col-sm-4"  style="padding-left: 0px">
                                    <span class="align-middle label-cust">{{orderDetailLabels.tipoOrdineLbl}}</span>
                                </div>
                                <input-w v-model="tipoOrdineValue" :configs="orderDetailLabels">
                                    <div class="col-xs-8 col-sm-8" ><input readonly v-model="tipoOrdineValue" type="text" id="tipoOrdineValueId" class="form-control form-control-cust" /></div>
                                </input-w>
                            </div>
                        </div>
                        </cfg>
                    </div>
                </div>

                <div class="row no-gutters">
                    <div class="col-xs-12 col-md-12">
                        <cfg cid="shopCart.numOrdCli" tag='div'>
                        <div class="col-xs-6 col-md-6">
                            <div class="form-group">
                                <div class="col-xs-4 col-sm-4" style="padding-left: 0px">
                                    <span class="align-middle label-cust">{{orderDetailLabels.numOrdineCliLbl}}</span>
                                </div>
                                <input-w v-model="numOrdineCliValue" :configs="orderDetailLabels">
                                    <div class="col-xs-8 col-sm-8"><input readonly  v-model="numOrdineCliValue" type="text" id="numOrdineCliValueId" class="form-control form-control-cust" /></div>
                                </input-w>
                            </div>
                        </div>
                        </cfg>
                        <cfg cid="shopCart.scontoBase" tag='div'>
                        <div v-if="!$root.token.hidePrices  && showScontoBase" class="col-xs-6 col-md-6">
                            <div class="form-group">
                                <div class="col-xs-4 col-sm-4"  style="padding-left: 0px">
                                    <span class="align-middle label-cust">{{orderDetailLabels.scontoBaseLbl}}</span>
                                </div>
                                <input-w v-model="scontoBaseValue" :configs="orderDetailLabels">
                                    <div class="col-xs-8 col-sm-8"><input readonly  v-model="scontoBaseValue" type="text" id="scontoBaseValueId" class="form-control form-control-cust" /></div>
                                </input-w>
                            </div>
                        </div>
                        </cfg>
                    </div>
                </div>
                <div class="row">
                    <div class="col-xs-12 col-sm-12 col-md-12">
                            <div class="form-group">
                                <div class="col-xs-2 col-sm-2" style="padding-left: 0px">
                                    <span class="align-middle label-cust">{{orderDetailLabels.clienteLbl}}</span>
                                </div>
                                <input-w v-model="clienteValue" :configs="orderDetailLabels">
                                    <div class="col-xs-10 col-sm-10 padLeft10"><input readonly  v-model="clienteValue" type="text" id="clienteValueId" class="form-control form-control-cust" /></div>
                                </input-w>
                            </div>
                    </div>
                </div>
                <div class="row">
                        <div class="col-xs-12 col-md-12">
                            <div class="form-group">
                                <div class="col-xs-2 col-sm-2" style="padding-left: 0px">
                                    <span class="align-middle label-cust">{{orderDetailLabels.utenteLbl}}</span>
                                </div>
                                <input-w v-model="utenteValue" :configs="orderDetailLabels">
                                    <div class="col-xs-10 col-sm-10 padLeft10"><input readonly  v-model="utenteValue" type="text" id="utenteValueId" class="form-control form-control-cust" /></div>
                                </input-w>
                            </div>
                        </div>
                </div>

                <div class="row no-gutters">
                    <div class="col-xs-12 col-md-12">
                        <div class="col-xs-6 col-md-6">
                            <div class="form-group">
                                <div class="col-xs-4 col-sm-4" style="padding-left: 0px">
                                    <span class="align-middle label-cust">{{orderDetailLabels.dataOrdineLbl}}</span>
                                </div>
                                <input-w v-model="dataOrdineValue" :configs="orderDetailLabels">
                                    <div class="col-xs-8 col-sm-8"><input readonly  v-model="dataOrdineValue" type="text" id="dataOrdineValueId" class="form-control form-control-cust" /></div>
                                </input-w>
                            </div>
                        </div>
                        <cfg cid="shopCart3.shippingType" tag='div'>
                        <div class="col-xs-6 col-md-6">
                            <div class="form-group">
                                <div class="col-xs-4 col-sm-4"  style="padding-left: 0px">
                                    <span class="align-middle label-cust">{{orderDetailLabels.tipoSpedizioneLbl}}</span>
                                </div>
                                <input-w v-model="tipoSpedizioneValue" :configs="orderDetailLabels">
                                    <div class="col-xs-8 col-sm-8"><input readonly  v-model="tipoSpedizioneValue" type="text" id="tipoSpedizioneId" class="form-control form-control-cust" /></div>
                                </input-w>
                            </div>
                        </div>
                        </cfg>
                    </div>
                    
                </div>
                <div class="row no-gutters">
                    <div class="col-xs-12 col-md-12">
                        <cfg cid="shopCart3.reqDeliveryDate" tag='div'>
                        <div class="col-xs-6 col-md-6">
                            <div class="form-group">
                                <div class="col-xs-4 col-sm-4" style="padding-left: 0px">
                                    <span class="align-middle label-cust">{{orderDetailLabels.dataConsRichiestaLbl}}</span>
                                </div>
                                <input-w v-model="dataConsRichiestaValue" :configs="orderDetailLabels">
                                    <div class="col-xs-8 col-sm-8"><input readonly  v-model="dataConsRichiestaValue" type="text" id="dataConsRichiestaId" class="form-control form-control-cust" /></div>
                                </input-w>
                            </div>
                        </div>
                        </cfg>
                        <cfg cid="shopCart.importo" tag='div'>
                        <div v-if="!$root.token.hidePrices" class="col-xs-6 col-md-6">
                            <div class="form-group">
                                <div class="col-xs-4 col-sm-4"  style="padding-left: 0px">
                                    <span class="align-middle label-cust">{{orderDetailLabels.valutaLbl}}</span>
                                </div>
                                <input-w v-model="valutaValue" :configs="orderDetailLabels">
                                    <div class="col-xs-8 col-sm-8"><input readonly  v-model="valutaValue" type="text" id="valutaId" class="form-control form-control-cust" /></div>
                                </input-w>
                            </div>
                        </div>
                        </cfg>
                    </div>
                </div>
                <div class="row no-gutters">
                    <div class="col-xs-12 col-md-12">
                        <cfg cid="shopCart.dataConferma" tag='div'>
                        <div class="col-xs-6 col-md-6">
                            <div class="form-group">
                                <div class="col-xs-4 col-sm-4" style="padding-left: 0px">
                                    <span class="align-middle label-cust">{{orderDetailLabels.dataConfermaLbl}}</span>
                                </div>
                                <input-w v-model="dataConfermaValue" :configs="orderDetailLabels">
                                    <div class="col-xs-8 col-sm-8"><input readonly  v-model="dataConfermaValue" type="text" id="dataConfermaId" class="form-control form-control-cust" /></div>
                                </input-w>
                            </div>
                        </div>
                        </cfg>
                        <cfg cid="shopCart.importo" tag='div'>
                        <div v-if="!$root.token.hidePrices" class="col-xs-6 col-md-6">
                            <div class="form-group">
                                <div class="col-xs-4 col-sm-4"  style="padding-left: 0px">
                                    <span class="align-middle label-cust">{{orderDetailLabels.totOrdineLbl}}</span>
                                </div>
                                <input-w v-model="totOrdineValue" :configs="orderDetailLabels">
                                    <div class="col-xs-8 col-sm-8"><input readonly  v-model="totOrdineValue" type="text" id="totOrdineId" class="form-control form-control-cust" /></div>
                                </input-w>
                            </div>
                        </div>
                        </cfg>
                    </div>
                </div>
                <div class="row">
                    <cfg cid="shopCart.note" tag='div'>
                    <div class="form-group">
                        <div class="col-xs-12 col-md-12">
                            <div class="col-xs-2 col-sm-2" style="padding-left: 0px">
                                <span class="align-middle label-cust">{{orderDetailLabels.noteLbl}}</span>
                            </div>
                            <input-w v-model="noteValue" :configs="orderDetailLabels">
                                <div class="col-xs-10 col-sm-10 padLeft10"><input readonly  v-model="noteValue" type="text" id="noteId" class="form-control form-control-cust" /></div>
                            </input-w>
                        </div>
                    </div>
                    </cfg>
                </div>                
                <div class="row">
                    <cfg cid="shopCart.noteGestore" tag='div'>
                    <div class="form-group">
                        <div class="col-xs-12 col-md-12">
                            <div class="col-xs-2 col-sm-2" style="padding-left: 0px">
                                <span class="align-middle label-cust">{{orderDetailLabels.noteGestLbl}}</span>
                            </div>
                            <input-w v-model="noteGestValue" :configs="orderDetailLabels">
                                <div class="col-xs-10 col-sm-10 padLeft10"><input readonly  v-model="noteGestValue" type="text" id="noteGestId" class="form-control form-control-cust" /></div>
                            </input-w>
                        </div>
                    </div>
                    </cfg>
                </div>                      
            </div>                      
            <div class="container-fluid shadow">
                <cfg cid="shopCart3.portType" tag='div'>
                <div class="row">
                    <div class="col-xs-12 col-md-12">
                        <div class="form-group">
                            <div class="col-xs-2 col-sm-2" style="padding-left: 0px">
                                <span class="align-middle label-cust">{{orderDetailLabels.portoLbl}}</span>
                            </div>
                            <input-w v-model="portoValue" :configs="orderDetailLabels">
                                <div class="col-xs-10 col-sm-10 padLeft10"><input readonly  v-model="portoValue" type="text" id="portoValueId" class="form-control form-control-cust" /></div>
                            </input-w>
                        </div>
                    </div>
                </div>
                </cfg>
                <cfg cid="shopCart.destinatarioIndirizzo" tag='div'>
                <div class="row">
                     <div class="col-xs-12 col-md-12">
                        <div class="form-group">
                            <div class="col-xs-2 col-sm-2" style="padding-left: 0px">
                                <span class="align-middle label-cust">{{orderDetailLabels.destinatarioLbl}}</span>
                            </div>
                            <input-w v-model="destinatarioValue" :configs="orderDetailLabels">
                                <div class="col-xs-10 col-sm-10 padLeft10"><input readonly  v-model="destinatarioValue" type="text" id="destinatarioId" class="form-control form-control-cust" /></div>
                            </input-w>
                        </div>
                    </div>
                </div>
                </cfg>
                <div class="row">
                     <div class="col-xs-12 col-md-12">
                            <div class="form-group">
                                <div class="col-xs-2 col-sm-2" style="padding-left: 0px">
                                    <span class="align-middle label-cust">{{orderDetailLabels.indirizzoLbl}}</span>
                                </div>
                                <input-w v-model="indirizzoValue" :configs="orderDetailLabels">
                                    <div class="col-xs-10 col-sm-10 padLeft10"><input readonly  v-model="indirizzoValue" type="text" id="indirizzoId" class="form-control form-control-cust" /></div>
                                </input-w>
                            </div>
                        </div>
                </div>
                <div class="row">
                     <div class="col-xs-12 col-md-12">
                            <div class="form-group">
                                <div class="col-xs-2 col-sm-2" style="padding-left: 0px">
                                    <span class="align-middle label-cust">{{orderDetailLabels.localitaLbl}}</span>
                                </div>
                                <input-w v-model="localitaValue" :configs="orderDetailLabels">
                                    <div class="col-xs-10 col-sm-10 padLeft10"><input readonly  v-model="localitaValue" type="text" id="localitaId" class="form-control form-control-cust" /></div>
                                </input-w>
                            </div>
                        </div>
                </div>
                <div class="row no-gutters">
                    <div class="col-xs-12 col-md-12">
                        <div class="col-xs-6 col-md-6" >
                            <div class="form-group">
                                <div class="col-xs-4 col-sm-4" style="padding-left: 0px">
                                    <span class="align-middle label-cust">{{orderDetailLabels.capLbl}}</span>
                                </div>
                                <input-w v-model="capValue" :configs="orderDetailLabels">
                                    <div class="col-xs-8 col-sm-8"><input readonly  v-model="capValue" type="text" id="capId" class="form-control form-control-cust" /></div>
                                </input-w>
                            </div>
                        </div>
                        <div class="col-xs-6 col-md-6">
                            <div class="form-group">
                                <div class="col-xs-4 col-sm-4" style="padding-left: 0px">
                                    <span class="align-middle label-cust">{{orderDetailLabels.regioneLbl}}</span>
                                </div>
                                <input-w v-model="regioneValue" :configs="orderDetailLabels">
                                    <div class="col-xs-8 col-sm-8"><input readonly  v-model="regioneValue" type="text" id="regioneId" class="form-control form-control-cust" /></div>
                                </input-w>
                            </div>
                        </div>
                    </div>                  
                </div>
                <div class="row no-gutters">
                    <div class="col-xs-12 col-md-12" >
                        <div class="col-xs-6 col-md-6">
                            <div class="form-group">
                                <div class="col-xs-4 col-sm-4" style="padding-left: 0px">
                                    <span class="align-middle label-cust">{{orderDetailLabels.provinciaLbl}}</span>
                                </div>
                                <input-w v-model="provinciaValue" :configs="orderDetailLabels">
                                    <div class="col-xs-8 col-sm-8"><input readonly  v-model="provinciaValue" type="text" id="provinciaId" class="form-control form-control-cust" /></div>
                                </input-w>
                            </div>
                        </div>
                        <div class="col-xs-6 col-md-6">
                            <div class="form-group">
                                <div class="col-xs-4 col-sm-4">
                                    <span class="align-middle label-cust">{{orderDetailLabels.nazioneLbl}}</span>
                                </div>
                                <input-w v-model="nazioneValue" :configs="orderDetailLabels">
                                    <div class="col-xs-8 col-sm-8"><input readonly  v-model="nazioneValue" type="text" id="nazioneId" class="form-control form-control-cust" /></div>
                                </input-w>
                            </div>
                        </div>
                    </div>                                  
                </div>
                <div class="row">
                </div>
            </div>                      
            <div class="container-fluid shadow">
                <div class="row">
                    <div class="col-xs-12 col-md-12">
                        <div class="form-group">
                            <div style="padding: 5px;">
                                <grid :columns="gridProdAttributesCfg.columns"
                                        :source.sync="arrayToTable" :options="options" :others="others"
                                        :lang="$root.token.idLingua" :name="gridProdAttributesCfg.title">
                                </grid>
                            </div>
                        </div>
                    </div>
                </div>                
                <div class="row">
                    <div class="col-xs-12 col-md-12">&nbsp;</div>
                </div>
            </div>
        </form>

        <div v-if="this.sendingCart" style="opacity:1; background: rgba(255, 255, 255, 0.65); z-index: 9999; position: fixed;
            top: 0;
            left: 0;
            width: 100vw;
            height: 100vh;transition: opacity 0.3s;
            transform: translate3D(0, 0, 0);">
            <div class="sk-cube-grid" style="margin-top: 20%;">
                <div class="sk-cube sk-cube1 loading-nav-waiter"></div>
                <div class="sk-cube sk-cube2 loading-nav-waiter"></div>
                <div class="sk-cube sk-cube3 loading-nav-waiter"></div>
                <div class="sk-cube sk-cube4 loading-nav-waiter"></div>
                <div class="sk-cube sk-cube5 loading-nav-waiter"></div>
                <div class="sk-cube sk-cube6 loading-nav-waiter"></div>
                <div class="sk-cube sk-cube7 loading-nav-waiter"></div>
                <div class="sk-cube sk-cube8 loading-nav-waiter"></div>
                <div class="sk-cube sk-cube9 loading-nav-waiter"></div>
            </div>
        </div>

    </div>
</template>


<script>

var w;
$(document).ready(function() {
  w =  $(window).width();
});

import Grid from '../../dynamic/jqwGridWrapper/jqwGridWrapper.vue'
import InputW from '../../dynamic/inputWrapper/inputWrapper.vue'
import FormMixin from '../../dynamic/inputWrapper/formMixin.js'
import DynTableWrapper from "../../dynamic/DynTableWrapper.vue";
import vSelect from "../../dynamic/vueSelectWrapper/components/Select.vue"
import table_resize_mixin from "../../../mixins/table_resize_mixin.js";
import { eventBus } from "../../../eventbus";
import Cfg from "../../dynamic/ConfigurableComponent.vue";

export default {
    mixins: [FormMixin],
    components: {
        Grid,
        InputW,
        DynTableWrapper,
        vSelect,
        Cfg
    },
    data: function () {
        var vm = this;
        return {
           useContainerView: false,
            orderDetailLabels: {
                dettaglioOrdineLbl: vm.$Jed.firstUpperTranslate('order detail'),
                idLbl: vm.$Jed.firstUpperTranslate('id'),
                tipoOrdineLbl: vm.$Jed.firstUpperTranslate('order type'),
                statoOrdineLbl: vm.$Jed.firstUpperTranslate('order state'),
                numOrdineCliLbl: vm.$Jed.firstUpperTranslate('client order number'),
                scontoBaseLbl: vm.$Jed.firstUpperTranslate('base discount'),
                clienteLbl: vm.$Jed.firstUpperTranslate('customer'),
                utenteLbl: vm.$Jed.firstUpperTranslate('user'),
                portoLbl: vm.$Jed.firstUpperTranslate('port type'),
                dataOrdineLbl: vm.$Jed.firstUpperTranslate('order date'),
                tipoSpedizioneLbl: vm.$Jed.firstUpperTranslate('shipping'),
                destinatarioLbl: vm.$Jed.firstUpperTranslate('recipient'),
                valutaLbl: vm.$Jed.firstUpperTranslate('currency'),
                totOrdineLbl: vm.$Jed.firstUpperTranslate('order total'),
                indirizzoLbl: vm.$Jed.firstUpperTranslate('address'),
                dataConfermaLbl: vm.$Jed.firstUpperTranslate('confirm date'),
                dataConsRichiestaLbl: vm.$Jed.firstUpperTranslate('requested delivery date'),
                localitaLbl: vm.$Jed.firstUpperTranslate('Localita'),
                noteLbl: vm.$Jed.firstUpperTranslate('note', 2),
                capLbl:  vm.$Jed.firstUpperTranslate('CAP'),
                regioneLbl: vm.$Jed.firstUpperTranslate('region'),
                noteGestLbl: vm.$Jed.firstUpperTranslate('manager notes'),
                provinciaLbl: vm.$Jed.firstUpperTranslate('province'),
                nazioneLbl: vm.$Jed.firstUpperTranslate('country'),
                documentiLbL: vm.$Jed.firstUpperTranslate('documents'),
            },
            idValue: 'Id',                
            statoOrdineValue: 'Stato Ordine',
            numOrdineCliValue: 'Numero Ordine Cliente', 
            scontoBaseValue: 0,  
            clienteValue: 'Cliente',
            utenteValue: 'Utente',
            portoValue: 'Porto',
            dataOrdineValue: '',
            tipoSpedizioneValue: 'tiposped',
            destinatarioValue: 'destVal',
            dataConsRichiestaValue: '',
            dataConfermaValue: '',
            totOrdineValue: '',
            valutaValue: 'val',
            indirizzoValue: '',
            tipoOrdineValue: '',
            localitaValue: '',   
            noteValue: '',       
            capValue: '',
            regioneValue: '',
            noteValue:  '',   
            noteGestValue: '',    
            provinciaValue: '', 
            nazioneValue: '',
            changeStatusEnable: false,
            changeStatusNotClickable: true,
            changeStatusBtnLabel: this.$Jed.firstUpperTranslate('forward'),
            tipoOrdineOptionsValue: [{  
                value: 1,
                type: vm.$Jed.firstUpperTranslate('Standard')
            },{
                value: 2,
                type: vm.$Jed.firstUpperTranslate('Urgente')
            },{
                value: 3,
                type: vm.$Jed.firstUpperTranslate('Stock')
            }],
            APIGridShopCart: null,
            options: {
                    columnsresize: true,
                    columnsreorder: true,
                    columnsmenu: vm.$Components.ProdottiOrdine.options.columnsmenu,
                    rowsheight: 26,
                    theme: "light",
                    width: "100%",
                    selectionmode: "none",
                    pageable: true,
                    showfilterrow: false,
                    filterable: true,
                    sortable: true,
                    pageable: false,
                    autoheight: false,
                    height: 230,
                    rowdetails: true,
                    rowdetailstemplate: {
                        rowdetails:
                            "<div style='margin: 10px 10px 10px 0px;'>Override this</div>",
                        rowdetailsheight: 250 /* ! 230 + 20 ! */
                    },
                    /* configurando una griglia ricorsiva, impostare rowdetailstemplate.rowdetails height uguale all'altezza della griglia innestata ... 
                    ... (in questo caso definita con autoheight: false e height: 230), + 20px per tenere in considerazione e margini di default */
                    initrowdetails: "nested",
                    rendered: null,
                    ready: function(){
                        $("#ProdottiOrdine").jqxGrid('sortby', 'id', 'asc');
                    }
            },
            others:{
                adaptColumns: true
            },
            gridProdAttributesCfg: {
                    ID: "gridProdAttributesId",
                    title: "ProdottiOrdine",
                    label_title: "",
                    visible: true,
                    columns: {
                    configs:{
                        remove: {
                            text:"",
                            position: 0,
                            width: "3%", 
                            searchable: false,
                            filterable: false,
                            sortable: false,
                            align: "center",
                            iconcolumn: true,                           
                            geticonclass: function(data_row, index) {
                                if(vm.editableOrder){
                                    return vm.$root.icons.close;
                                }
                            },
                            onclick: function(obj) {
                                if(vm.editableOrder){
                                    var ok = function(){
                                        try{
                                            const index = vm.arrayToTable.indexOf(obj);                                
                                            if (index !== -1) {
                                                vm.arrayToTable.splice(index, 1);
                                            }

                                            //rimuovo effettivamente la riga ordine dal loki
                                            var rec = vm.reg_order_items.find({'id': obj.refObj.id})[0]
                                            vm.reg_order_items.remove(rec) 
                                            //alla fine delle op sui loki di ordini e righeordine salvo il loki db e chiedo la sync
                                            vm.$root.dbRegistry.saveDatabase(function(err) {
                                                if (err) {
                                                    console.log("saveDatabase - error : " + err);
                                                } else {
                                                    if(!vm.$root.preferences.useOffline)vm.$Sync.triggerUpdate() //nuova gestione sync nell'online
                                                    console.log("orderDetail: remove row - saveDatabase - database aggiornato");
                                                    eventBus.$emit("cartFilled",vm.$root.shopCartData.prodotti.length);
                                                }
                                            });

                                            this.close()
                                        }catch(e){
                                            eventBus.$emit('alert', {
                                                message: vm.$Jed.firstUpperTranslate("An error occurred in deleting order row. Please contact admin: %1$s", null, {
                                                    key: null,
                                                    string: e
                                                }), 
                                                type: "warning",
                                                action: ''
                                            })
                                        }
                                    },
                                    no = function(){
                                        this.close();
                                    },
                                    e = {
                                        message: vm.$Jed.firstUpperTranslate('Are you sure you want to delete the row with product %1$s?',null,{
                                            key: null,
                                            string: [obj.id+' - '+obj.descr]
                                        }),
                                        ok: ok,
                                        no: no
                                    }
                                    eventBus.$emit("confirm", e)
                                }
                            }
                        },
                        indice: {
                            text: vm.$Jed.firstUpperTranslate('code'),
                            position: 1,
                            visible: true,
                            editable: false,
                            width: "12%",
                            searchable: false,
                            sorting: true,
                            datafield: "id"
                        },
                        descr: {
                            text: vm.$Jed.firstUpperTranslate('description'),
                            position: 1,
                            visible: true,
                            editable: false,
                            width: vm.$root.token.hidePrices ? "36%":"18%",
                            searchable: false,
                            sorting: true,
                            datafield: "descr"
                        },
                        noter: {
                            text: vm.$Jed.firstUpperTranslate('row notes'),
                            position: 2,
                            visible: true,
                            editable: false,
                            width: "15%",
                            searchable: false,
                            sorting: true,
                            datafield: "noter"
                        },
                        //Note gestore
                        notei: {
                            text: vm.$Jed.firstUpperTranslate('manager notes'),
                            position: 3,
                            visible: true,
                            editable: false,
                            width: "15%",
                            searchable: false,
                            sorting: true,
                            datafield: "notei"
                        },
                        stato: {
                            text: vm.$Jed.firstUpperTranslate('row status'),
                            position: 4,
                            visible: true,
                            editable: false,
                            width: "7%",
                            searchable: false,
                            sorting: true,
                            datafield: "stato"
                        },
                        umis: {
                            text: vm.$Jed.firstUpperTranslate('unit of measure'),
                            position: 5,
                            visible: true,
                            editable: false,
                            width: "5%",
                            searchable: false,
                            sorting: true,
                            datafield: "uni"
                        },
                        qty: {
                            text: vm.$Jed.firstUpperTranslate('qty'),
                            position: 6,
                            visible: true,
                            editable: false,
                            width: "5%",
                            searchable: false,
                            sorting: true,
                            datafield: "qty",
                            cellsrenderer: function (data_row, datafield, value) {
                                if(value)return '<div style="display: table; width: 100%; height: 100%"><div style="display: table-cell; vertical-align: middle; text-align: center; "><span style="margin-right: 6px">' + Number(value).toLocaleString() + '</span></div></div>';
                            }
                        },
                        uprice: {
                            text: vm.$Jed.firstUpperTranslate('unitary price'),
                            position: 7,
                            visible: true,
                            editable: false,
                            hidden: vm.$root.token.hidePrices,
                            width: "9%",
                            searchable: false,
                            sorting: true,
                            datafield: "uprice",
                            cellsalign: 'right', 
                            tobecellsrenderered: function(datarow, row, columnfield, value, defaulthtml, columnproperties){
                                if(value && value != ""){
                                    var csy = datarow.csy ? datarow.csy : vm.$root.token.valuta
                                    return '<div style="display: table; width: 100%; height: 100%"><div style="display: table-cell; vertical-align: middle; text-align: ' + columnproperties.cellsalign + '"><span style="margin-right: 6px">' + Number(value).toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2}) + ' ' + csy + '</span></div></div>';
                                } else {
                                    return ""
                                }
                            }
                        },
                        totprice: {
                            text: vm.$Jed.firstUpperTranslate('final price'),
                            position: 8,
                            visible: true,
                            editable: false,
                            hidden: vm.$root.token.hidePrices,
                            width: "9%",
                            searchable: false,
                            sorting: true,
                            datafield: "fprice",
                            cellsalign: 'right', 
                            tobecellsrenderered: function(datarow, row, columnfield, value, defaulthtml, columnproperties){
                                if(value && value != ""){
                                    var csy = datarow.csy ? datarow.csy : vm.$root.token.valuta
                                    return '<div style="display: table; width: 100%; height: 100%"><div style="display: table-cell; vertical-align: middle; text-align: ' + columnproperties.cellsalign + '"><span style="margin-right: 6px">' + Number(value).toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2}) + ' ' + csy + '</span></div></div>';
                                } else {
                                    return ""
                                }
                            }
                        },
                        scArt:{
                            text: vm.$Jed.firstUpperTranslate('product discount'),
                            position: 14,
                            visible: true,
                            editable: false,
                            width: "9%",
                            searchable: false,
                            sorting: true,
                            datafield: "scArt"
                        },
                        trasp: {
                            text: "Trasp.",
                            position: 9,
                            width: "5%", 
                            searchable: false,
                            filterable: false,
                            sortable: false,
                            align: "center",
                            datafield: "trasp"
                        },
                        disp: {
                            text: vm.$Jed.firstUpperTranslate('availability'),
                            position: 10,
                            visible: true,
                            editable: false,
                            width: "5%",
                            searchable: false,
                            sorting: true,
                            datafield: "disp",
                            iconcolumn: true,
                            geticonclass: function(data_row, index) {
                                if(data_row.refObj.ava){
                                    return vm.$root.icons.circle;
                                }else{
                                    return vm.$root.icons.empty_circle;
                                }
                                return "";
                            }
                        },
                        data_disp: {
                            text: vm.$Jed.firstUpperTranslate('availability date'),
                            position: 11,
                            visible: true,
                            editable: false,
                            width: "5%",
                            searchable: false,
                            sorting: true,
                            datafield: "avd"
                        },
                        codlinea: {
                            text: vm.$Jed.firstUpperTranslate('line code'),
                            position: 11,
                            visible: true,
                            editable: false,
                            width: "9%",
                            searchable: false,
                            sorting: true,
                            datafield: "codlinea"
                        },
                        codmacch: {
                            text: vm.$Jed.firstUpperTranslate('machine code'),
                            position: 12,
                            visible: true,
                            editable: false,
                            width: "9%",
                            searchable: false,
                            sorting: true,
                            datafield: "codmacch"
                        },
                        desmacch: {
                            text: vm.$Jed.firstUpperTranslate('machine description'),
                            position: 13,
                            visible: true,
                            editable: false,
                            width: "22%",
                            searchable: false,
                            sorting: true,
                            datafield: "desmacch"
                        }  
                    }
                }
            },
            arrayToTable: [],
            focus: null,
            document: null,
            missingDeliveryInfo: true,
            missingDeliveryInfoWhich: [],
            riduzioneScontoValue: 0,
            showScontoBase: true,
            editableOrder: false,
            reg_order_items: vm.$root.dbRegistry.getCollection('orderItems'),
            reg_parameters: null,
            orderSynced: this.$route.params.id>0,
            righeOrdine: [],
            sendingCart: false
        }
    },
    watch: {
        totOrdineValue: function(){
            this.totOrdineValue = Number(this.totOrdineValue) ? Number(this.totOrdineValue).toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2}) : this.totOrdineValue;
        }
    },
    created:  function()  {
        console.log('Order Detail - created')
        if( w > 1000 )
            this.useContainerView = false;
        else 
            this.useContainerView = true;

        var id = this.$route.params.id;

        var vm = this;
        eventBus.$on("gotChanges",(ids)=>{ 
            /*è avvenuta una sync. 
            L'id nell'url può essere:
                -un numero positivo: se ero nel dettaglio di un ordine che era già stato sincronizzato.
                    In questo caso devo aggiornare gli id delle righe ordine perchè potrei aver aggiunto articoli a un ordine che era già stato sync
                -un numero negativo: se ero nel dettaglio di un ordine che non era ancora stato sincronizzato
            se nella sync è stato sincronizzato un ordine, l'evento di avvenuta sync si porterà dietro un oggetto col vecchio id (negativo) e il nuovo id dell'ordine
            Quindi controllo se l'id nell'url:
            - è negativo (significa che l'ordine è da sincronizzare)
            - è uguale al vecchio id che mi è arrivato dalla sync dell'ordine
            Allora cerco l'ordine nel registry in base all'id nuovo e aggiorno le informazioni dell'ordine mostrate a video.
            Questo controllo serve perchè altrimenti, quando arriva l'evento di avvenuta sync, scomparivano i valori del dettaglio ordine perchè l'id negativo 
            con cui facevo la ricerca nel registry era già stato sostituito dalla sync*/
            if(ids){
                if(id<0 && id == ids.old){
                    id = ids.new
                    vm.$root.getOrderDetail(id).then(order=>{
                        if(order)vm.updateData(order); //aggiorno dati ordine e righe ordine
                    })
                }else if(id>0){
                    vm.$root.getOrderDetail(id).then(order=>{
                        if(order)vm.updateData(order); //aggiorno dati ordine e righe ordine
                    })
                }
            }else if(id>0){
                vm.$root.getOrderDetail(id).then(order=>{
                    if(order)vm.updateData(order); //aggiorno dati ordine e righe ordine
                })
            }
            //sblocca pulsante anteprima di stampa:
            vm.orderSynced = true
            
            //sblocca pulsante procedi avanzamento ordine:
            vm.changeStatusNotClickable = false;
        }) 
        this.loadCollections();
    }, 
    mounted: function() {
        console.log('Order Detail - mounted')
        
        w = $(window).width();   
        if( w > 1000 )
            this.useContainerView = false;
        else 
            this.useContainerView = true;

        window.addEventListener('resize', this.handleWindowResize);

        var id = this.$route.params.id,
            vm = this;
        this.$root.getOrderDetail(id).then(order=>{
            if(order){
                vm.updateData(order); //aggiorno dati ordine e righe ordine
                
                //aggiorna disponibilità
                if(this.$Behaviors.erpgInterface){
                    //se lo stato corrente ha il flag default apertura
                    if(order.orderStatus && order.orderStatus.ope){
                        //se ci sono tutti i prezzi
                        var missingPrice = order.orderItems.some((p) => p.unp == '' || p.unp == null)
                        if(!missingPrice){
                            this.$root.updateAvailability();
                        }
                    }
                }
            }
        })
    },
    beforeDestroy: function () {
        window.removeEventListener('resize', this. handleWindowResize)
    },
    methods: {
        handleWindowResize(event) { 
            w = event.currentTarget.innerWidth;
            if( event.currentTarget.innerWidth > 1000 )
                this.useContainerView = false;
            else 
                this.useContainerView = true;
        },
        async loadCollections(){
            var vm = this;
            try {                
                vm.reg_parameters = await vm.$root.fetchRegistryData("parameters", "GetParameters", "collection");
            }catch(err){
                console.log(err)
            }
        },
        async updateData(order) { 
            console.log('UPDATE DATA')
            var vm = this;
            try{
                this.idValue = order.ordId;
                this.statoOrdineValue = order.statoOrdine;
                this.numOrdineCliValue = order.numOrdineCli; 

                this.scontoBaseValue = order.scontoBase;  

                this.clienteValue = order.clientId;
                this.utenteValue = order.userId;
                this.portoValue = order.tipoPort;
                this.dataOrdineValue = order.dataOrdine;
                this.tipoSpedizioneValue = order.tipoSpedizione;
                this.destinatarioValue = order.destinatario;
                this.dataConsRichiestaValue =  order.dataConsRich;
                this.valutaValue = order.valutaOrdine,
                this.indirizzoValue = order.indirizzo;

                this.tipoOrdineValue = order.tipoOrdine;

                this.localitaValue = order.localita;
                this.capValue = order.cap;
                this.regioneValue = order.regione;
                this.noteValue = order.note;
                this.provinciaValue = order.provincia; 
                this.nazioneValue = order.nazione;
                this.noteValue = order.note;
                this.noteGestValue = order.noteGestore;  
                this.totOrdineValue = order.totaleOrdine;

                /*
                 * gestione cambio stato ordine
                */
                this.changeStatusEnable = (order && order.orderStatus && order.orderStatus.nes);
                this.changeStatusNotClickable = !(order && order.orderStatus && order.orderStatus.nes);
                
                if(this.changeStatusEnable === false) {
                    $('#changeStatusBtnId').removeClass('btn-primary-default');
                    $('#changeStatusBtnId').addClass('btn-light');
                }

                if(order.refObj && order.refObj.osi == 5){ //Se il distributore ha cambiato stato in "Da confermare"
                    this.changeStatusEnable = true;
                    this.changeStatusNotClickable = false;
                    this.changeStatusBtnLabel = this.$Jed.firstUpperTranslate('confirm')
                }   

                /*
                 * gestione stato ordine modificabile
                */
                this.editableOrder = (order && order.orderStatus &&  order.orderStatus.mod)

                /*
                 * controllo il porto e le info di consegna e spedizione 
                */
                var shipDelivInfos;
                if(!this.$Behaviors.shopCart2Alternate){
                    if(order.refObj && order.refObj.pti){
                        if(order.tipoPortFre){ // se il porto è franco posso avanzare l'ordine anche se non c'è il tipoSpedizione
                            shipDelivInfos = {address: order.indirizzo, "postal code": order.cap, place: order.localita, country: order.nazione}
                            if(order.indirizzo && order.cap && order.localita && order.nazione){
                                this.missingDeliveryInfo = false;
                            }else{
                                this.missingDeliveryInfo = true;
                                for(var i in shipDelivInfos){
                                    if(!shipDelivInfos[i])this.missingDeliveryInfoWhich.push(i)
                                }
                            }
                        }else{
                            shipDelivInfos = {address: order.indirizzo, "postal code": order.cap, place: order.localita, country: order.nazione, "Tipo Spedizione": order.tipoSpedizione}
                            if(order.indirizzo && order.cap && order.localita && order.nazione && order.tipoSpedizione){
                                this.missingDeliveryInfo = false;
                            }else{
                                this.missingDeliveryInfo = true;
                                for(var i in shipDelivInfos){
                                    if(!shipDelivInfos[i])this.missingDeliveryInfoWhich.push(i)
                                }
                            }
                        }
                    }else{
                        shipDelivInfos = {address: order.indirizzo, "postal code": order.cap, place: order.localita, country: order.nazione, "Tipo Spedizione": order.tipoSpedizione, "port type": order.tipoPort}
                        this.missingDeliveryInfo = true;
                        for(var i in shipDelivInfos){
                            if(!shipDelivInfos[i])this.missingDeliveryInfoWhich.push(i)
                        }
                    }
                }else{
                    shipDelivInfos = {address: order.indirizzo, "postal code": order.cap, place: order.localita, country: order.nazione}
                    if(order.indirizzo && order.cap && order.localita && order.nazione){
                        this.missingDeliveryInfo = false;
                    }else{
                        this.missingDeliveryInfo = true;
                        for(var i in shipDelivInfos){
                            if(!shipDelivInfos[i])this.missingDeliveryInfoWhich.push(i)
                        }
                    }
                }
                
                /*
                 * recupero documenti allegati all'ordine
                */
                var reg_documents;
                var id = order && order.ordId ? order.ordId.toString() : ''
                if(this.$root.preferences.useOffline){
                    if(vm.$root.dbServRegistry == null ) {
                        console.log("OrderDetail - Registry not loaded!");
                        return;
                    }else{
                        reg_documents = this.$root.dbServRegistry.getCollection('documents');
                    }   
                }else{
                    reg_documents = await this.$root.fetchRegistryData("document", "GetDocuments", "collection",{oid: id, oty: 'Ordini'})
                }

                if(reg_documents){
                    var doc = reg_documents.find({oid: id})
                    if(doc && doc.length>0){
                        doc = doc[0]
                        this.document = {}
                        this.document['name'] = doc.nam;
                        this.document['link'] = this.$root.msPath +"/"+ this.$Configs.licenseId +"/documenti/"+doc.fna;
                    }
                }

                /* 
                 * ricalcolo entrambe le colonne che mostrano lo sconto articolo/cliente
                */
                if(vm.$Configs.discountReductPerc){
                    vm.$root.getOrderTypeOptions(vm.$root.token.idCliente).then(result=>{
                        var tipoOrdineItem = result && result.length>0 ? result.find(o => o.type == this.tipoOrdineValue ) : 'Standard'; //recupero il tipo ordine dal carrello              
                        if((tipoOrdineItem && tipoOrdineItem.type == 'Urgente' && vm.$Configs.discountReductPerc)){ //se è stabilita una percentuale di riduzione sconto (TM Racing)
                            vm.showScontoBase = false;
                            //riduzione di sconto per l'ordine urgente: se è generica sta in discountReductPerc, se è specifica per cliente è nel value del typeOrder Urgente
                            vm.riduzioneScontoValue = tipoOrdineItem.value ? tipoOrdineItem.value : vm.$Configs.discountReductPerc
                        }else{
                            vm.riduzioneScontoValue = 0
                            vm.showScontoBase = vm.$Configs.discountReductPerc ? false : true;
                        }
                        this.refreshGrid(order.orderItems);
                    })
                }else{
                    this.refreshGrid(order.orderItems);
                }

                //metto le righe ordine in una var accessibile in tutta la classe vue
                this.righeOrdine = order.orderItems;
            
            }catch(e){
                console.log(e)
            }
        },
        changeStep: function(val) { 
            if( val != 3)           
                this.$emit('changeComponentEvent',val, this.getData())  ;  
        },
        refreshGrid(items) {
            this.arrayToTable = [];
            var elem, finalPrice, colSc;
            if(items){
                for(var idx = 0; idx < items.length; idx++){       
                    elem = items[idx];
                    elem.unp = elem.unp ? parseFloat(elem.unp) ? parseFloat(elem.unp).toFixed(2) : '' : elem.ulp;
                    finalPrice = elem.unp ?  (elem.qty * elem.unp).toFixed(2) : ''
                    if(this.riduzioneScontoValue || this.riduzioneScontoValue == 0){ //devo ricalcolare gli sconti sia quando la percentuale di riduzione ha un valore > 0 sia quando è 0 (ordine std) per tornare agli sconti iniziali
                        var scCliView = elem.cd1 - (elem.cd1 / 100 * this.riduzioneScontoValue),
                            scArtView = elem.cd2 - (elem.cd2 / 100 * this.riduzioneScontoValue)
                    }  
                    colSc = scCliView && scArtView ? scCliView + ' + ' + scArtView : scArtView ? scArtView : scCliView ? scCliView : ''
                    this.arrayToTable.push({
                        refObj: elem,
                        id: elem.pid != 0 ? elem.pid : '', 
                        descr: elem.ide,
                        noter: elem.not ? elem.not : '',
                        notei: elem.cno,
                        qty: elem.qty,
                        uprice: elem.unp, /* (elem.csy ? elem.csy : this.$root.token.valuta) + ' ' +  */
                        fprice: finalPrice, /* (elem.csy ? elem.csy : this.$root.token.valuta) + ' ' + */
                        stato: elem.sta,
                        uni: this.$Jed.translate(elem.uni),
                        avd: elem.avd ? new Date(elem.avd).toLocaleString() : "",
                        codlinea: elem.ldi,
                        codmacch: elem.mpi,
                        desmacch: elem.mde,
                        scArt: colSc
                    })
                }  
            }             
        },
        checkAvailAndPrice(orderStatus){
            console.log(this.righeOrdine)
            console.log(orderStatus)
            //se l'ordine è in uno stato con il flag default apertura, verifico prezzi e disponibilità
            if(orderStatus && orderStatus.ope){
                //se il prodotto in ordine non è disponibile
                //oppure
                //il prezzo unitario è vuoto o nullo
                //allora
                //l'ordine andrà in attesa di verifica
                var ca = this.righeOrdine.some((p) => !p.ava)           
                var cp = this.righeOrdine.some((p) => p.unp == '' || p.unp == null)
                console.log(ca)
                console.log(cp)
                return ca || cp;
            }else{
                //se lo stato dell'ordine non ha il flag default apertura, verifico solo la disponibilità (o la data disponibilità)
                //ovvero l'ordine andrà in attesa di verifica se il prodotto non è disponibile o se la data disponibilità è vuota o nulla
                //(some - ce n'è almeno uno?)
                //metto AND perchè almeno una delle due deve essere valida: cioè se sul prodotto non c'è nè la disponibilità nè la data dispo, allora va in verifica
                var cd = this.righeOrdine.some((p) => !p.ava && (p.avd == '' || p.avd == null))
                return cd;
            }
        },
        changeStatusClick () {
            var vm = this;
            if(this.missingDeliveryInfo){
                var newmdiw = this.missingDeliveryInfoWhich.map(i => vm.$Jed.firstUpperTranslate(i))
                eventBus.$emit("alert", {
                    type: "warning", 
                    message: vm.$Jed.firstUpperTranslate('To progress the order, complete delivery and shipping info before: %1$s', null, 
                        {
                            key: null,
                            string: [newmdiw.join(', ')]
                        }
                    )
                });
                return;
            }else{
                var change = this.$root.orderProgress(this.idValue),
                    reg_orders = this.$root.dbRegistry.getCollection('orders'),
                    reg_orderStatus = this.$root.dbRegistry.getCollection('orderStatuses'),
                    order = reg_orders.findOne({  'id': this.idValue  }),
                    orderStatus = reg_orderStatus.findOne({ 'id': order.osi }),
                    vm = this,
                    ok = function(){
                        vm.changeStatusNotClickable = true;
                        var vma = this;

                        vm.sendingCart = true;

                        if(vm.$Behaviors.erpgInterface){
                            var check = vm.checkAvailAndPrice(orderStatus);
                            console.log(check)
                            if(check){
                                //c'è almeno un prodotto non disponibile 
                                //o
                                //c'è almeno un prodotto con il prezzo non definito
                                console.log('in attesa di verifica')
                                
                                //imposto stato ordine con id dello stato "da verificare"
                                var idStato = vm.reg_parameters.find({id: 'Id Stato Ordine Da Verificare'})[0].val

                                console.log('changeStatusClick - OrderDetail: aggiorno stato ordine: '+ order.id+ ' da: ' + order.osi + ' a: '+idStato);                                    
                                order.osi = Number(idStato)
                                reg_orders.update(order);
                                
                                //alla fine delle op sui loki di ordini e righeordine salvo il loki db e chiedo la sync
                                vm.$root.dbRegistry.saveDatabase(function(err) {
                                    var orderStatusStr = '';
                                    if (err) {
                                        console.log("saveDatabase - error : " + err);
                                        orderStatusStr = err;
                                    } else {
                                        if(!vm.$root.preferences.useOffline)vm.$Sync.triggerUpdate() //nuova gestione sync nell'online
                                        console.log("orderDetail: stato ordine - saveDatabase - database aggiornato");
                                           
                                        var orderStatus = vm.$root.dbRegistry.getCollection('orderStatuses').findOne({ 'id': Number(idStato) });
                                        if(orderStatus) {
                                            orderStatusStr = orderStatus.des[vm.$root.token.siglaLingua] ? orderStatus.des[vm.$root.token.siglaLingua] : orderStatus.des[vm.$root.token.defaultLang];
                                        }
                                    }
                                    
                                    vm.sendingCart = false;

                                    vm.$root.simpleNotification("success", {
                                        title: vm.$Jed.firstUpperTranslate('order state'), 
                                        message: vm.$Jed.firstUpperTranslate(orderStatusStr) 
                                    });

                                });

                            }else{
                                this.$root
                                .microservice({
                                role: "erpg",
                                cmd: "GetOrderState",
                                params: {
                                    orderId: order.id,
                                    mode: 1
                                    // 0 = chiamata da pulsante invia al terzo passo carrello,
                                    // 1 = chiamata da pulsante procedi in dettaglio archivio ordini,
                                    // 2 = chiamata da pulsante richiedi offerta al terzo passo carrello
                                }
                                }).then((response) => {
                                    var res = response.body,
                                        message,
                                        pickup = null,
                                        mail = null,
                                        time = null;
                                    
                                    vm.sendingCart = false;

                                    try {
                                        if(res.stato){
                                            message = vm.reg_parameters.find({val: ''+res.stato+''})[0].id
                                        }else if(res.err){
                                            message = 'order not confirmed'
                                        }
                                        if(!res.mailInviata){
                                            mail = 'mail not sent'
                                        }
                                        if(res.ritiroInGiornataDaOra){
                                            time = vm.reg_parameters.find({id: 'Ora Ordine Utile Per Ritiro In Giornata'})[0].val
                                            pickup = 'day pick up %1$s'
                                        }

                                        var e = {
                                            icon: "info",
                                            title: this.$Jed.firstUpperTranslate('order state'),
                                            message: this.$Jed.firstUpperTranslate(message) + (pickup ? ' \n '+this.$Jed.firstUpperTranslate(pickup, null, {key: time}) : '') + (mail ? ' '+this.$Jed.firstUpperTranslate(mail) : ''),
                                            ok: function(){
                                                this.close();
                                            },
                                            YtxtBtn: this.$Jed.firstUpperTranslate('Ok')
                                        }
                                        eventBus.$emit("confirm", e)

                                        
                                    } catch (err) {
                                        console.log(err)
                                        var e = {
                                            icon: "error",
                                            title: this.$Jed.firstUpperTranslate('error'),
                                            message: err,
                                            ok: function(){
                                                this.close();
                                            },
                                            YtxtBtn: this.$Jed.firstUpperTranslate('Ok')
                                        }
                                        eventBus.$emit("alert", e)
                                    }

                                    //dopo aver chiamato il cmd che aggiorna lo stato ordine, chiamo la sync
                                    if(!vm.$root.preferences.useOffline)vm.$Sync.triggerUpdate(); //nuova gestione sync nell'online                   
                                    
                                }, (error) => {
                            
                                    //vedi gestione errore in main.js > microservice

                                })
                                .catch(err => {
                                    console.log(err);
                                    var msg = err && err.body && err.body.error ? err.body.error : err
                                    eventBus.$emit('alert', {
                                        message: "Application caught an error <br> <h5>Details: " + "erpg.GetOrderState - " + msg +'</h5>',
                                        type: "error",
                                        action: ''
                                    })
                                })
                            }
                        }else{
                            if(order.osi != change.to){
                                order.osi = change.to;
                                reg_orders.update(order);
                                console.log('OrderDetail: Aggiornato ordine con id:', order.id, order); 
                                //alla fine delle op sui loki di ordini e righeordine salvo il loki db e chiedo la sync
                                vm.$root.dbRegistry.saveDatabase(function(err) {
                                    if (err) {
                                        console.log("saveDatabase - error : " + err);
                                    } else {
                                        if(!vm.$root.preferences.useOffline)vm.$Sync.triggerUpdate() //nuova gestione sync nell'online
                                        console.log("orderDetail: stato ordine - saveDatabase - database aggiornato");
                                        vm.sendingCart = false;
                                        eventBus.$emit("cartFilled",vm.$root.shopCartData.prodotti.length);
                                    }
                                });
                            }
                            
                            vm.$root.getOrderDetail(vm.idValue).then(order=>{
                                if(order){
                                    vm.updateData(order).then(()=>{
                                        vma.close();
                                    }); 
                                }
                            })
                        }
                    },
                    no = function(){
                        this.close();
                    },
                    mod = change.toMod ? this.$Jed.translate('editable') : this.$Jed.translate('not')+' '+this.$Jed.translate('editable'),
                    e = {
                        message: this.$Jed.firstUpperTranslate('Do you want to progress the order? It will go from')+' "'+change.fromDes+'" '+this.$Jed.translate('to')+' "'+change.toDes+'" ('+mod+')', 
                        ok: ok,
                        no: no
                    }
                eventBus.$emit("confirm", e);
            }  
        },
        previousClick () {
            this.$router.push({name: 'OrdersArch'});
        }
    }
}


</script>

<style>
.form-control-cust  {
    height: 28px;
}

.label-cust {
    white-space: nowrap;
}

.v-select input[type=search], .v-select input[type=search]:focus {
    flex-basis: 20px;
    flex-grow: 1;
    height: 28px;
    padding: 0 20px 0 10px;
    width: 100% !important;
}

.padLeft10 {
    padding-left: 10px;
}

.row.no-gutters > [class^="col-"],
.row.no-gutters > [class*=" col-"] {
  padding-right: 0;
  padding-left: 0;
    padding-bottom: 1px;
    padding-top: 1px;
}

</style>



// WEBPACK FOOTER //
// src/components/views/shopcart/OrderDetail.vue?c8f40b32